import { render, staticRenderFns } from "./Douyin.vue?vue&type=template&id=d1e8fa9a&scoped=true"
import script from "./Douyin.vue?vue&type=script&lang=js"
export * from "./Douyin.vue?vue&type=script&lang=js"
import style0 from "./Douyin.vue?vue&type=style&index=0&id=d1e8fa9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e8fa9a",
  null
  
)

export default component.exports